<template>
  <div class="layout-header">
    <!-- <div v-if="isStyle2"><el-image
      style="margin-top: 10px;
    position: absolute;
    z-index: 1;"
      src="../../static/image/headbg.png"
      fit="fit"></el-image>
      <p class="head-title">车辆电池告警平台</p></div> -->
    <div class="title" :style="{ width: slideWidth }">
      <div class="inner" @click="goTo_Detail" style="cursor:pointer">
        {{ companyTitle }}
      </div>
    </div>

    <i
      :class="triggerClass"
      v-on:click="handleTrigger"
      style="z-index:10;position:relative;"
    ></i>

    <div class="toolbar" style="z-index:10;position:relative;" v-if="!isStyle2">
      <el-menu
        :default-active="activeIndex"
        :class="isStyle2 ? 'el-menu-demo' : ''"
        mode="horizontal"
      >
        <el-submenu index="0">
          <template slot="title">
            <span class="text"
              >当前公司：{{ this.$store.state.login.companyName }}</span
            >
          </template>
          <span
            v-for="(company1, index) in this.$store.state.login.user"
            v-bind:key="index"
          >
            <el-menu-item
              v-if="!company1.children || company1.children.length == 0"
              :index="company1.id"
            >
              <div @click="handleSelect(company1.id, company1.name)">
                {{ company1.name }}
              </div>
            </el-menu-item>
            <el-submenu v-else :index="company1.id">
              <template slot="title">
                <div @click="handleSelect(company1.id, company1.name)">
                  {{ company1.name }}
                </div>
              </template>

              <span
                v-for="(company2, index) in company1.children"
                v-bind:key="index"
              >
                <el-menu-item
                  v-if="!company2.children || company2.children.length == 0"
                  :index="company2.id"
                >
                  <div @click="handleSelect(company2.id, company2.name)">
                    {{ company2.name }}
                  </div>
                </el-menu-item>
                <el-submenu v-else :index="company2.id">
                  <template slot="title">
                    <div @click="handleSelect(company2.id, company2.name)">
                      {{ company2.name }}
                    </div>
                  </template>

                  <span
                    v-for="(company3, index) in company2.children"
                    v-bind:key="index"
                  >
                    <el-menu-item
                      v-if="!company3.children || company3.children.length == 0"
                      :index="company3.id"
                    >
                      <div @click="handleSelect(company3.id, company3.name)">
                        {{ company3.name }}
                      </div>
                    </el-menu-item>
                    <el-submenu v-else :index="company3.id">
                      <template slot="title">
                        <div @click="handleSelect(company3.id, company3.name)">
                          {{ company3.name }}
                        </div>
                      </template>
                      <el-menu-item
                        v-for="(company4, index) in company3.children"
                        :index="company4.id"
                        v-bind:key="index"
                      >
                        <div @click="handleSelect(company4.id, company4.name)">
                          {{ company4.name }}
                        </div>
                      </el-menu-item>
                    </el-submenu>
                  </span>
                </el-submenu>
              </span>
            </el-submenu>
          </span>
        </el-submenu>
        <el-submenu index="21">
          <template slot="title"
            ><span class="text">当前用户：{{ userName }}</span></template
          >
          <el-menu-item index="2-1"
            ><span @click="dialogVisible = true">修改密码</span></el-menu-item
          >
        </el-submenu>
        <el-menu-item index="32">
          <span
            class="logout text"
            v-on:click="logout"
            style="padding-left: 15px"
          >
            <i class="el-icon-switch-button"></i>退出登录
          </span>
        </el-menu-item>
      </el-menu>
    </div>

    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="60%"
      center
    >
      <el-form
        ref="uploadPwdForm"
        :model="form"
        :rules="rules"
        label-width="100px"
        style="width: 80%; text-align: center; margin: auto"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="form.oldPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="form.newPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmNewPassword">
          <el-input
            v-model="form.confirmNewPassword"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updatePassword">确定</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import fieldFilter from "@/utils/fieldFilter.js";
import router from "@/router";
export default {
  name: "Header",
  data() {
    let validateNewPassword = (rule, value, callback) => {
      if (value === this.form.oldPassword) {
        callback(new Error("新密码不能与原密码相同!"));
      } else {
        callback();
      }
    };
    let validateConfirmNewPassword = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error("与新密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      initialized: false,
      companyTitle: "",
      userName: "",
      dialogVisible: false,
      form: {
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: ""
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "blur"
          }
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur"
          },
          {
            validator: validateNewPassword,
            trigger: "blur"
          }
        ],
        confirmNewPassword: [
          {
            required: true,
            message: "请输入确认新密码",
            trigger: "blur"
          },
          {
            validator: validateConfirmNewPassword,
            trigger: "blur"
          }
        ]
      },

      triggerType: "open",
      triggerClass: "el-icon-s-fold",
      activeIndex: "1"
    };
  },
  created: function() {
    if (!this.initialized) {
      this.initialized = true;
      // console.log("Heade111111111111r created");
      this.$store.dispatch("login/getCur");
      this.$store.dispatch("login/getOrg");
      this.$store.dispatch("login/getMenu");
    }
  },
  computed: {},

  methods: {
    goTo_Detail() {
      router.push("/bigScreen");
    },
    handleSelect: function(id) {
      this.$store.dispatch("login/changeCompany", {
        companyId: id
      });
    },
    logout: function() {
      this.$confirm("是否要退出系统？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$store.dispatch("login/logout");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出登录"
          });
        });
    },
    handleTrigger: function(e) {
      if (this.triggerType == "open") {
        this.triggerType = "close";
        this.triggerClass = "el-icon-s-unfold";
      } else {
        this.triggerType = "open";
        this.triggerClass = "el-icon-s-fold";
      }
      //触发父组件定义的menu-trigger-event自定义事件
      this.$emit("menu-trigger-event", this.triggerType);
    },
    updatePassword: function() {
      const dataForm = this.form;
      this.$refs["uploadPwdForm"].validate(valid => {
        if (valid) {
          const data = fieldFilter.filter(dataForm, [
            "oldPassword",
            "newPassword"
          ]);
          this.$store.dispatch("form/handle", {
            url: "/user/login/updatePwd",
            data: data,
            method: "post",
            callback: resp => {
              this.dialogVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  beforeMount() {
    this.userName = localStorage.getItem("userName");
    // console.log(this.userName);
    this.$store.dispatch("form/handle", {
      url: "/user/login/getCurInfo",
      callback: resp => {
        let companyId = resp.companyId;
        this.$store.dispatch("form/handle", {
          url: "/battery/offline/query",
          data: { companyId: companyId },
          method: "get",
          callback: resp => {
            if (resp.title) {
              this.companyTitle = resp.title;
            }
          }
        });
      }
    });
  },

  props: ["slideWidth", "isStyle2"]
};
</script>

<style scoped lang="less">
@import "./Header.less";
.layout-header
  /deep/
  .el-menu--horizontal
  > .el-submenu:hover
  .el-submenu__title {
  background-color: transparent;
}
.layout-header /deep/ .el-menu--horizontal .el-menu .el-submenu__title {
  background-color: transparent;
}
.layout-header /deep/ .el-menu--horizontal .el-menu .el-menu-item {
  background-color: transparent;
}
.layout-header
  /deep/
  .el-menu--horizontal
  > .el-menu-item:not(.is-disabled):hover {
  background-color: transparent;
}
.head-title {
  background-image: linear-gradient(135deg, #0d115d, #02d0fc, #0d115d);
  // -webkit-background-clip:text;
  color: transparent;
  position: absolute;
  width: 100%;
  font-size: 30px;
  top: -20px;
  text-align: center;
}
</style>

<style>
.header .toolbar > .el-menu > .el-submenu i {
  color: #ffffff;
}

.header .toolbar .el-menu--horizontal {
  border: none;
}
.header .toolbar .el-menu--horizontal > .el-submenu .el-submenu__title {
  margin: 0 15px;
}
.header .toolbar .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  background-color: #9bd186;
}

.header .toolbar .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: #9bd186;
}

.el-menu--horizontal ul span li .el-submenu__title div {
  width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-menu--horizontal ul span .el-menu-item div {
  width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-submenu__icon-arrow {
  position: absolute;
  top: 50%;
  right: 2px;
  margin-top: -7px;
}

.el-dialog .el-dialog__header {
  background: rgba(0, 204, 0, 1);
}
.el-dialog .el-dialog__header .el-dialog__title {
  font-size: 25px;
  font-weight: bolder;
  color: #fff;
}
.el-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  font-size: 25px;
  color: #fff;
}
.el-dialog .el-dialog__body .el-form .el-form-item .el-form-item__label {
  color: #000;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue